export const ALLOWED_TERMINAL_IDS: number[] = [1, 209, 4, 153, 611, 863, 189, 109, 384, 642, 725, 188];

export function isCityDeliveryDispatchAllowed(terminalId: number | undefined): boolean {
  return terminalId != null && ALLOWED_TERMINAL_IDS.includes(terminalId);
}
